// @ts-nocheck
/** All UI strings — use t('key') only. Never use lang === 'bn' ? ... : ... */
const translations = {
    en: {
        appName: "SS Real Estate Manager",
        appNameShort: "SREM",
        appSubtitle: "Manager",
        dashboard: "Dashboard",
        projects: "Projects",
        inventory: "Inventory",
        materials: "Materials",
        crm: "CRM / Leads",
        bookings: "Bookings",
        payments: "Payments",
        accounts: "Accounts",
        users: "Users",
        reports: "Reports",
        system: "System",
        permissions: "Permissions",
        advanced: "Advanced",
        bankAssets: "Bank & Assets",
        acReports: "A/C Reports",
        chat: "Chat",
        myPortal: "My Portal",
        myBookings: "My Bookings",
        myPayments: "My Payments",
        profile: "Profile",
        profileSettings: "Profile settings",
        viewProfile: "View profile",
        logout: "Logout",
        login: "Sign In",
        welcomeBack: "Welcome back",
        signInContinue: "Sign in to continue to your workspace",
        email: "Email",
        password: "Password",
        welcome: "Welcome",
        overview: "Overview of operations",
        totalProjects: "Projects",
        totalUnits: "Total units",
        available: "Available",
        totalBookings: "Bookings",
        pendingPayments: "Pending Payments",
        collected: "Collected (BDT)",
        overdue: "Overdue installments",
        quickActions: "Quick actions",
        newProject: "New Project",
        editProject: "Edit project",
        addUnit: "Add unit",
        bulkAdd: "Bulk add",
        editUnit: "Edit unit",
        newLead: "New Lead",
        newBooking: "New booking",
        recordPayment: "Record Payment",
        save: "Save",
        cancel: "Cancel",
        create: "Create",
        update: "Update",
        delete: "Delete",
        view: "View",
        edit: "Edit",
        actions: "Actions",
        status: "Status",
        name: "Name",
        phone: "Phone",
        amount: "Amount",
        date: "Date",
        search: "Search",
        noData: "No data found",
        loading: "Loading...",
        language: "Language",
        theme: "Theme",
        light: "Light",
        dark: "Dark",
        colorTheme: "Color",
        green: "Green",
        blue: "Blue",
        purple: "Purple",
        teal: "Teal",
        orange: "Orange",
        materialsStock: "Construction Materials",
        materialsDesc: "Building development inventory",
        stockValue: "Stock value",
        lowStock: "Low Stock",
        totalItems: "Total Items",
        suppliers: "Suppliers",
        transactions: "Stock Movements",
        purchase: "Purchase",
        issue: "Issue to Site",
        return: "Return",
        adjustment: "Adjustment",
        wastage: "Wastage",
        category: "Category",
        unit: "Unit",
        currentStock: "Current Stock",
        minStock: "Min Stock",
        unitCost: "Unit Cost",
        addMaterial: "Add Material",
        addSupplier: "Add Supplier",
        stockIn: "Stock In / Out",
        accountsTitle: "Accounts & Expenses",
        accountsDesc: "Chart of accounts and project expenses",
        chartOfAccounts: "Chart of Accounts",
        expenses: "Expenses",
        totalExpense: "Total Expense",
        pendingApproval: "Pending Approval",
        approve: "Approve",
        reject: "Reject",
        addExpense: "Add Expense",
        accountCode: "Code",
        accountType: "Type",
        balance: "Balance",
        title: "Title",
        project: "Project",
        paymentMethod: "Payment Method",
        demoLogin: "Quick demo accounts",
        admin: "Admin",
        sales: "Sales",
        finance: "Finance",
        customer: "Customer",
        super: "Super",
        required: "This field is required",
        invalidEmail: "Enter a valid email",
        minPassword: "Password must be at least 6 characters",
        minLength: "Too short",
        maxLength: "Too long",
        mustBeNumber: "Must be a number",
        mustBePositive: "Must be positive",
        selectProject: "Select project",
        selectUnit: "Select unit",
        selectCustomer: "Select customer",
        code: "Code",
        location: "Location",
        address: "Address",
        description: "Description",
        unitNumber: "Unit number",
        floor: "Floor",
        block: "Block",
        unitType: "Unit type",
        sizeSqft: "Size (sqft)",
        salePrice: "Sale price",
        bedrooms: "Bedrooms",
        bathrooms: "Bathrooms",
        buildingPlan: "Building plan",
        buildingExpression: "Building expression",
        blocks: "Blocks",
        unitsPerFloor: "Units per floor",
        numbering: "Numbering",
        defaultPrice: "Default price",
        previewFloors: "Preview floors",
        generateUnits: "Generate units",
        skipExisting: "Skip existing numbers",
        bulkUnitsTitle: "Bulk add units (building plan)",
        bulkUnitsHelp: "Patterns: G+10, BG+10, B+G+12, B1+B2+G+15, or 1-12",
        allProjects: "All Projects",
        allStatus: "All Status",
        booked: "Booked",
        sold: "Sold",
        reserved: "Reserved",
        planning: "Planning",
        ongoing: "Ongoing",
        completed: "Completed",
        handedOver: "Handed over",
        successCreate: "Created successfully",
        successUpdate: "Updated successfully",
        successDelete: "Deleted successfully",
        successSave: "Saved successfully",
        successApprove: "Approved successfully",
        successReject: "Rejected successfully",
        failed: "Something went wrong",
        confirmDelete: "Are you sure you want to delete?",
        confirmApprove: "Approve this item?",
        confirmReject: "Reject this item?",
        confirmCancel: "Cancel this booking?",
        noUnitsHint: "No units — use Bulk add for G+10 / BG+10 buildings",
        manageProjects: "Manage real estate projects",
        inventoryDesc: "Units / Flats / Land Shares",
        source: "Source",
        notes: "Notes",
        assigned: "Assigned",
        interestProject: "Project interest",
        bookingNo: "Booking no",
        bookingDate: "Booking date",
        bookingMoney: "Booking money",
        discount: "Discount",
        commission: "Commission %",
        receipt: "Receipt",
        method: "Method",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        notifications: "Notifications",
        markAllRead: "Mark all read",
        noNotifications: "No notifications",
        loggedInAs: "Logged in as",
        creating: "Creating…",
        saving: "Saving…",
        portalDisabled: "Portal disabled",
        flat: "Flat",
        apartment: "Apartment",
        landShare: "Land share",
        parking: "Parking",
        shop: "Shop",
        commercial: "Commercial",
        office: "Office",
        website: "Website",
        walkIn: "Walk-in",
        referral: "Referral",
        socialMedia: "Social Media",
        other: "Other",
        cash: "Cash",
        bank: "Bank",
        cheque: "Cheque",
        mobileBanking: "Mobile banking",
        card: "Card",
        requiredField: "Required",
        selectOption: "Select…",
        preset: "Preset…",
        version: "Version",
        unitsCreated: "unit(s) created",
        showPassword: "Show password",
        hidePassword: "Hide password",
        inventoryMaterials: "Inventory & Materials",
        materialsPageDesc: "Categories, stock, suppliers & account links",
        supportChat: "Support Chat",
        chatPageDesc: "Chat with our team. You will get notifications for new messages.",
        noMessagesYet: "No messages yet — say hello!",
        typeMessage: "Type a message…",
        dashboardDesc: "Projects, sales, collections & inventory at a glance",
        payment: "Payment",
        occupancySold: "Occupancy / sold",
        leads: "Leads",
        collectionsBookingsChart: "Collections & bookings (6 months)",
        unitInventoryMix: "Unit inventory mix",
        financeSnapshot: "Finance snapshot",
        recentPayments: "Recent payments",
        recentBookings: "Recent bookings",
        professionalAccountsReports: "Professional Accounts & Reports",
        runReport: "Run Report",
        systemAdministration: "System Administration",
        systemAdminDesc: "Module on/off, user active/inactive, soft-delete recovery",
        bankCurrencyAssets: "Bank, Currency & Fixed Assets",
        portalSubtitle: "Your bookings, payments, project status & chat",
        totalPayable: "Total Payable",
        totalPaid: "Total Paid",
        totalDue: "Total Due",
        paymentHistory: "Payment History",
        noBookingsYet: "No bookings yet",
        projectLabel: "Project: ",
        expected: "Expected",
        salePriceLabel: "Sale Price",
        paid: "Paid",
        due: "Due",
        nextPayment: "Next payment",
        detailsInstallments: "Details & Installments",
        accountsReportsDesc: "Financial year, trial balance, balance sheet, income & expenditure, receipts & payments, ledgers & cash flow",
        welcome_user: "Welcome, {{name}}",
        status_available: "Available",
        status_booked: "Booked",
        status_sold: "Sold",
        status_reserved: "Reserved",
        status_transferred: "Transferred",
        status_pending: "Pending",
        status_confirmed: "Confirmed",
        status_cancelled: "Cancelled",
        status_handed_over: "Handed over",
        status_approved: "Approved",
        status_rejected: "Rejected",
        status_planning: "Planning",
        status_ongoing: "Ongoing",
        status_completed: "Completed",
        status_active: "Active",
        status_inactive: "Inactive",
        unit_type_flat: "Flat",
        unit_type_apartment: "Apartment",
        unit_type_land_share: "Land share",
        unit_type_parking: "Parking",
        unit_type_shop: "Shop",
        unit_type_commercial: "Commercial",
        unit_type_office: "Office",
        unit_type_other: "Other",
        payment_method_cash: "Cash",
        payment_method_bank: "Bank",
        payment_method_cheque: "Cheque",
        payment_method_mobile_banking: "Mobile banking",
        payment_method_card: "Card",
        payment_method_bkash: "bKash",
        payment_method_nagad: "Nagad",
        payment_method_rocket: "Rocket",
        role_super_admin: "Super Admin",
        role_admin: "Admin",
        role_sales: "Sales",
        role_finance: "Finance",
        role_customer: "Customer",
        lead_source_website: "Website",
        lead_source_walk_in: "Walk-in",
        lead_source_referral: "Referral",
        lead_source_social_media: "Social Media",
        lead_source_other: "Other",
        tx_type_purchase: "Purchase",
        tx_type_issue: "Issue to site",
        tx_type_return: "Return",
        tx_type_adjustment: "Adjustment",
        tx_type_wastage: "Wastage",
        account_type_asset: "Asset",
        account_type_liability: "Liability",
        account_type_equity: "Equity",
        account_type_income: "Income",
        account_type_expense: "Expense",
        created_count: "Created {{count}} item(s)",
        units_created_n: "{{count}} unit(s) created",
        hello_user: "Hello, {{name}}",
        project_colon: "Project: {{name}}",
        next_payment_on: "Next payment: {{date}}",
        paid_of_total: "Paid {{paid}} of {{total}}",
        parkingOnBg: "Basement & ground = parking",
        parkingOnBgHelp: "B / G floors create parking units; typical floors create selected unit type",
        parkingUnitsPerFloor: "Parking slots / floor",
        parkingPrice: "Parking price",
        previewLabel: "Preview",
        floorsLabel: "floors",
        blocksLabel: "blocks",
        perFloor: "/floor",
        residentialUnits: "Residential",
        parkingUnits: "Parking",
        totalUnitsLabel: "Total",
        unitsWord: "units",
        optional: "optional",
        prefix: "Prefix",
    // en
conversations: 'Conversations', selectConversation: 'Select a conversation to start chatting',
companySettings: 'Company Settings', appearance: 'Appearance',
    },
    bn: {
        appName: "এসএস রিয়েল এস্টেট ম্যানেজার",
        appNameShort: "SREM",
        appSubtitle: "ম্যানেজার",
        dashboard: "ড্যাশবোর্ড",
        projects: "প্রজেক্ট",
        inventory: "ইনভেন্টরি",
        materials: "সামগ্রী",
        crm: "সিআরএম / লিড",
        bookings: "বুকিং",
        payments: "পেমেন্ট",
        accounts: "অ্যাকাউন্টস",
        users: "ইউজার",
        reports: "রিপোর্ট",
        system: "সিস্টেম",
        permissions: "অনুমতি",
        advanced: "অ্যাডভান্সড",
        bankAssets: "ব্যাংক ও সম্পদ",
        acReports: "অ্যাকাউন্ট রিপোর্ট",
        chat: "চ্যাট",
        myPortal: "আমার পোর্টাল",
        myBookings: "আমার বুকিং",
        myPayments: "আমার পেমেন্ট",
        profile: "প্রোফাইল",
        profileSettings: "প্রোফাইল সেটিংস",
        viewProfile: "প্রোফাইল দেখুন",
        logout: "লগআউট",
        login: "সাইন ইন",
        welcomeBack: "আবার স্বাগতম",
        signInContinue: "কাজে চালিয়ে যেতে সাইন ইন করুন",
        email: "ইমেইল",
        password: "পাসওয়ার্ড",
        welcome: "স্বাগতম",
        overview: "কার্যক্রমের সারসংক্ষেপ",
        totalProjects: "প্রজেক্ট",
        totalUnits: "মোট ইউনিট",
        available: "উপলব্ধ",
        totalBookings: "বুকিং",
        pendingPayments: "মুলতুবি পেমেন্ট",
        collected: "আদায় (BDT)",
        overdue: "বকেয়া কিস্তি",
        quickActions: "দ্রুত কাজ",
        newProject: "নতুন প্রজেক্ট",
        editProject: "প্রজেক্ট সম্পাদনা",
        addUnit: "ইউনিট যোগ",
        bulkAdd: "বাল্ক যোগ",
        editUnit: "ইউনিট সম্পাদনা",
        newLead: "নতুন লিড",
        newBooking: "নতুন বুকিং",
        recordPayment: "পেমেন্ট রেকর্ড",
        save: "সংরক্ষণ",
        cancel: "বাতিল",
        create: "তৈরি",
        update: "আপডেট",
        delete: "মুছুন",
        view: "দেখুন",
        edit: "সম্পাদনা",
        actions: "কর্ম",
        status: "স্ট্যাটাস",
        name: "নাম",
        phone: "ফোন",
        amount: "পরিমাণ",
        date: "তারিখ",
        search: "খুঁজুন",
        noData: "কোনো তথ্য নেই",
        loading: "লোড হচ্ছে...",
        language: "ভাষা",
        theme: "থিম",
        light: "লাইট",
        dark: "ডার্ক",
        colorTheme: "রঙ",
        green: "সবুজ",
        blue: "নীল",
        purple: "বেগুনি",
        teal: "টিল",
        orange: "কমলা",
        materialsStock: "নির্মাণ সামগ্রী",
        materialsDesc: "বিল্ডিং ডেভেলপমেন্ট ইনভেন্টরি",
        stockValue: "স্টক মূল্য",
        lowStock: "কম স্টক",
        totalItems: "মোট আইটেম",
        suppliers: "সরবরাহকারী",
        transactions: "স্টক চলাচল",
        purchase: "ক্রয়",
        issue: "সাইটে ইস্যু",
        return: "ফেরত",
        adjustment: "সমন্বয়",
        wastage: "অপচয়",
        category: "ক্যাটাগরি",
        unit: "একক",
        currentStock: "বর্তমান স্টক",
        minStock: "সর্বনিম্ন স্টক",
        unitCost: "একক মূল্য",
        addMaterial: "সামগ্রী যোগ",
        addSupplier: "সরবরাহকারী যোগ",
        stockIn: "স্টক ইন / আউট",
        accountsTitle: "অ্যাকাউন্টস ও খরচ",
        accountsDesc: "চার্ট অফ অ্যাকাউন্টস এবং প্রজেক্ট খরচ",
        chartOfAccounts: "চার্ট অফ অ্যাকাউন্টস",
        expenses: "খরচ",
        totalExpense: "মোট খরচ",
        pendingApproval: "অনুমোদনের অপেক্ষায়",
        approve: "অনুমোদন",
        reject: "বাতিল",
        addExpense: "খরচ যোগ",
        accountCode: "কোড",
        accountType: "ধরন",
        balance: "ব্যালেন্স",
        title: "শিরোনাম",
        project: "প্রজেক্ট",
        paymentMethod: "পেমেন্ট পদ্ধতি",
        demoLogin: "ডেমো অ্যাকাউন্ট",
        admin: "অ্যাডমিন",
        sales: "সেলস",
        finance: "ফিন্যান্স",
        customer: "কাস্টমার",
        super: "সুপার",
        required: "এই ঘরটি আবশ্যক",
        invalidEmail: "সঠিক ইমেইল দিন",
        minPassword: "পাসওয়ার্ড কমপক্ষে ৬ অক্ষর",
        minLength: "খুব ছোট",
        maxLength: "খুব বড়",
        mustBeNumber: "সংখ্যা হতে হবে",
        mustBePositive: "ধনাত্মক হতে হবে",
        selectProject: "প্রজেক্ট বেছে নিন",
        selectUnit: "ইউনিট বেছে নিন",
        selectCustomer: "কাস্টমার বেছে নিন",
        code: "কোড",
        location: "লোকেশন",
        address: "ঠিকানা",
        description: "বিবরণ",
        unitNumber: "ইউনিট নম্বর",
        floor: "ফ্লোর",
        block: "ব্লক",
        unitType: "ইউনিট ধরন",
        sizeSqft: "সাইজ (sqft)",
        salePrice: "বিক্রয় মূল্য",
        bedrooms: "বেডরুম",
        bathrooms: "বাথরুম",
        buildingPlan: "বিল্ডিং প্ল্যান",
        buildingExpression: "বিল্ডিং এক্সপ্রেশন",
        blocks: "ব্লক",
        unitsPerFloor: "প্রতি ফ্লোরে ইউনিট",
        numbering: "নম্বারিং",
        defaultPrice: "ডিফল্ট মূল্য",
        previewFloors: "ফ্লোর প্রিভিউ",
        generateUnits: "ইউনিট তৈরি",
        skipExisting: "আগের নম্বর বাদ দিন",
        bulkUnitsTitle: "বাল্ক ইউনিট (বিল্ডিং প্ল্যান)",
        bulkUnitsHelp: "প্যাটার্ন: G+10, BG+10, B+G+12, B1+B2+G+15, বা 1-12",
        allProjects: "সব প্রজেক্ট",
        allStatus: "সব স্ট্যাটাস",
        booked: "বুকড",
        sold: "বিক্রিত",
        reserved: "রিজার্ভড",
        planning: "পরিকল্পনা",
        ongoing: "চলমান",
        completed: "সম্পন্ন",
        handedOver: "হস্তান্তর",
        successCreate: "সফলভাবে তৈরি হয়েছে",
        successUpdate: "সফলভাবে আপডেট হয়েছে",
        successDelete: "সফলভাবে মুছে ফেলা হয়েছে",
        successSave: "সফলভাবে সংরক্ষণ",
        successApprove: "অনুমোদন হয়েছে",
        successReject: "বাতিল হয়েছে",
        failed: "কিছু ভুল হয়েছে",
        confirmDelete: "মুছে ফেলতে চান?",
        confirmApprove: "অনুমোদন করবেন?",
        confirmReject: "বাতিল করবেন?",
        confirmCancel: "বুকিং বাতিল করবেন?",
        noUnitsHint: "ইউনিট নেই — G+10 / BG+10 এর জন্য বাল্ক যোগ ব্যবহার করুন",
        manageProjects: "রিয়েল এস্টেট প্রজেক্ট পরিচালনা",
        inventoryDesc: "ইউনিট / ফ্ল্যাট / ল্যান্ড শেয়ার",
        source: "সোর্স",
        notes: "নোট",
        assigned: "অ্যাসাইনড",
        interestProject: "আগ্রহের প্রজেক্ট",
        bookingNo: "বুকিং নং",
        bookingDate: "বুকিং তারিখ",
        bookingMoney: "বুকিং মানি",
        discount: "ছাড়",
        commission: "কমিশন %",
        receipt: "রসিদ",
        method: "পদ্ধতি",
        pending: "মুলতুবি",
        approved: "অনুমোদিত",
        rejected: "বাতিল",
        notifications: "নোটিফিকেশন",
        markAllRead: "সব পঠিত",
        noNotifications: "কোনো নোটিফিকেশন নেই",
        loggedInAs: "লগইন",
        creating: "তৈরি হচ্ছে…",
        saving: "সংরক্ষণ হচ্ছে…",
        portalDisabled: "পোর্টাল বন্ধ",
        flat: "ফ্ল্যাট",
        apartment: "অ্যাপার্টমেন্ট",
        landShare: "ল্যান্ড শেয়ার",
        parking: "পার্কিং",
        shop: "শপ",
        commercial: "কমার্শিয়াল",
        office: "অফিস",
        website: "ওয়েবসাইট",
        walkIn: "ওয়াক-ইন",
        referral: "রেফারেল",
        socialMedia: "সোশ্যাল মিডিয়া",
        other: "অন্যান্য",
        cash: "নগদ",
        bank: "ব্যাংক",
        cheque: "চেক",
        mobileBanking: "মোবাইল ব্যাংকিং",
        card: "কার্ড",
        requiredField: "আবশ্যক",
        selectOption: "বাছুন…",
        preset: "প্রিসেট…",
        version: "ভার্সন",
        unitsCreated: "টি ইউনিট তৈরি",
        showPassword: "পাসওয়ার্ড দেখুন",
        hidePassword: "পাসওয়ার্ড লুকান",
        inventoryMaterials: "ইনভেন্টরি / সামগ্রী",
        materialsPageDesc: "ক্যাটাগরি, স্টক, সরবরাহকারী ও অ্যাকাউন্ট লিংক",
        supportChat: "সাপোর্ট চ্যাট",
        chatPageDesc: "আমাদের টিমের সাথে যোগাযোগ করুন। নতুন মেসেজে নোটিফিকেশন পাবেন।",
        noMessagesYet: "এখনো কোনো মেসেজ নেই — লিখুন!",
        typeMessage: "মেসেজ লিখুন…",
        dashboardDesc: "প্রজেক্ট, বিক্রয়, আদায় ও ইনভেন্টরির সারসংক্ষেপ",
        payment: "পেমেন্ট",
        occupancySold: "অকুপেন্সি",
        leads: "লিড",
        collectionsBookingsChart: "মাসিক আদায় ও বুকিং",
        unitInventoryMix: "ইউনিট স্ট্যাটাস",
        financeSnapshot: "আর্থিক সারাংশ",
        recentPayments: "সাম্প্রতিক পেমেন্ট",
        recentBookings: "সাম্প্রতিক বুকিং",
        professionalAccountsReports: "পেশাদার অ্যাকাউন্টস ও রিপোর্ট",
        runReport: "রিপোর্ট দেখুন",
        systemAdministration: "সিস্টেম অ্যাডমিন",
        systemAdminDesc: "মডিউল চালু/বন্ধ, ইউজার অ্যাকটিভ/ইনঅ্যাকটিভ, সফট ডিলিট রিকভারি",
        bankCurrencyAssets: "ব্যাংক, মুদ্রা ও স্থায়ী সম্পদ",
        portalSubtitle: "আপনার বুকিং, পেমেন্ট, প্রজেক্ট স্ট্যাটাস ও চ্যাট",
        totalPayable: "মোট মূল্য",
        totalPaid: "কত টাকা দিয়েছেন",
        totalDue: "কত দিতে হবে",
        paymentHistory: "পেমেন্ট হিস্ট্রি",
        noBookingsYet: "এখনো কোনো বুকিং নেই",
        projectLabel: "প্রজেক্ট: ",
        expected: "সম্পন্ন হওয়ার সম্ভাব্য তারিখ",
        salePriceLabel: "মোট",
        paid: "দিয়েছেন",
        due: "বাকি",
        nextPayment: "পরবর্তী পেমেন্ট",
        detailsInstallments: "বিস্তারিত ও কিস্তি",
        accountsReportsDesc: "আর্থিক বছর, ট্রায়াল ব্যালেন্স, ব্যালেন্স শিট, আয়-ব্যয়, রসিদ-পেমেন্ট, লেজার ও ক্যাশ ফ্লো",
// bn
conversations: 'কথোপকথন', selectConversation: 'চ্যাট শুরু করতে একটি কথোপকথন নির্বাচন করুন',
companySettings: 'কোম্পানি সেটিংস', appearance: 'চেহারা',
    },
};

export default translations;
